import { number, object } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const validationSchema = object({
	endRentDate: number()
		.required(validationErrMessages.endRentDate),
});
